class HomePageExtras {
  initHomeTabs () {
    const tabs = {
      first: {
        buttons: document.querySelectorAll('.tabs-wrapper ul.list_tabs li'),
        contents: document.querySelectorAll('.tabs-wrapper .tab-content'),
        banners: document.querySelectorAll('.tabs-wrapper .list_banner')
      },
      second: {
        buttons: document.querySelectorAll('.tabs-wrapper-alt ul.list_tabs li'),
        contents: document.querySelectorAll('.tabs-wrapper-alt .tab-content'),
        banners: document.querySelectorAll('.tabs-wrapper-alt .list_banner')
      }
    }

    const activeClassTokens = {
      buttons: ['current'],
      contents: ['current'],
      banners: ['img-current']
    }

    for (const currentTab of Object.values(tabs)) {
      for (const currentTabButton of currentTab.buttons) {
        currentTabButton.addEventListener('click', (e) => {
          const tabId = currentTabButton.attributes.getNamedItem('data-tab')
          for (const [entityType, entityData] of Object.entries(currentTab)) {
            for (const el of entityData) {
              el.classList.remove(...activeClassTokens[entityType])
            }
          }
          currentTabButton.classList.add(...activeClassTokens.buttons)
          document.getElementById(tabId.value).classList.add(...activeClassTokens.contents)
          document.getElementById(`tab-img-${tabId.value}`).classList.add(...activeClassTokens.banners)
        }, { passive: true })
      }
    }
  }

  initCategoryTabList () {
    const tabButtons = document.querySelectorAll('ul.sml_slider_tabs li')
    const tabGroups = document.querySelectorAll('.home_cat_slider_main')
    if (tabGroups.length < 1 || tabButtons < 1) {
      return
    }
    document.querySelector('.home_cat_slider_main#slideTab-1').classList.add('active_slider')
    document.querySelector('ul.sml_slider_tabs li[data-slider-id="slideTab-1"]').classList.add('tab_slide_active')
    for (const tabButton of tabButtons) {
      tabButton.addEventListener('click', () => {
        const catNavTabId = tabButton.attributes.getNamedItem('data-slider-id')
        for (const tabButtonToRemoveActiveClass of tabButtons) {
          tabButtonToRemoveActiveClass.classList.remove('tab_slide_active')
        }
        for (const tabGroupToRemoveActiveClass of tabGroups) {
          tabGroupToRemoveActiveClass.classList.remove('active_slider')
        }
        tabButton.classList.add('tab_slide_active')
        document.querySelector('#' + catNavTabId.value).classList.add('active_slider')
      })
    }
  }

  initMainSliderObserver () {
    const mainSliderListItems = document.querySelectorAll(
      '.sml_main_slider_wrapper.native_slider .native_slider-lg .native_slider-li'
    )
    const mainSliderListItemCaptions = document.querySelectorAll(
      '.sml_main_slider_wrapper.native_slider .native_slider-lg .native_slider-li .main-slide-details'
    )
    const mainSliderCaptionOpts = {
      root: document.querySelector('.sml_main_slider_wrapper.native_slider .native_slider-lg'),
      rootMargin: '0px',
      threshold: 0.98
    }
    const mainSliderObserver = new IntersectionObserver((intersectedEntries) => {
      for (const intersectedEntry of intersectedEntries) {
        if (!intersectedEntry.isIntersecting) {
          continue
        }
        const captionsEl = intersectedEntry.target.querySelector('.main-slide-details')
        for (const otherCaption of mainSliderListItemCaptions) {
          otherCaption.classList.remove('animation-started')
        }
        if (null === captionsEl) {
          continue
        }
        captionsEl.classList.add('animation-started')
      }
    }, mainSliderCaptionOpts)
    for (const mainSliderListItem of mainSliderListItems) {
      mainSliderObserver.observe(mainSliderListItem)
    }
  }

  init () {
    this.initHomeTabs()
    this.initCategoryTabList()
    this.initMainSliderObserver()
  }
}

document.addEventListener('DOMContentLoaded', function (e) {
  window._homepageExtras = new HomePageExtras()
  window._homepageExtras.init()
}, false)
